import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=5df43f6c&"
import script from "./InfoIcon.vue?vue&type=script&lang=js&"
export * from "./InfoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports